import { StateCreator } from 'zustand'
import { ContactForm } from '@types'

export interface ContactSlice {
  contact: {
    form: ContactForm
    isLoading: boolean
    isSubmitted: boolean
    error: string | null
    updateForm: (data: Partial<ContactForm>) => void
    resetForm: () => void
    submitForm: () => Promise<void>
  }
}

const initialForm: ContactForm = {
  name: '',
  email: '',
  company: '',
  service: '',
  message: '',
  budget: '',
  timeline: '',
}

export const createContactSlice: StateCreator<ContactSlice> = (set) => ({
  contact: {
    form: initialForm,
    isLoading: false,
    isSubmitted: false,
    error: null,

    updateForm: (data: Partial<ContactForm>) => {
      set((state) => ({
        contact: {
          ...state.contact,
          form: { ...state.contact.form, ...data },
        },
      }))
    },

    resetForm: () => {
      set((state) => ({
        contact: {
          ...state.contact,
          form: initialForm,
          isSubmitted: false,
          error: null,
        },
      }))
    },

    submitForm: async () => {
      set((state) => ({
        contact: {
          ...state.contact,
          isLoading: true,
          error: null,
        },
      }))

      try {
        // Simular envío de formulario
        await new Promise((resolve) => setTimeout(resolve, 2000))

        set((state) => ({
          contact: {
            ...state.contact,
            isLoading: false,
            isSubmitted: true,
          },
        }))
      } catch (error) {
        set((state) => ({
          contact: {
            ...state.contact,
            isLoading: false,
            error: 'Error al enviar el formulario. Inténtalo de nuevo.',
          },
        }))
      }
    },
  },
}) 